import { Component } from 'src/utils';
import logoIcon from './../../../images/small-logo.png';
import houseIcon from './../../../images/house-icon.png';
import user from './../../../images/user.png';
import searchIcon from './../../../images/search.png';
import template from './user-profile.html';
import higlightedmarkerIcon from './../../../images/wbu-pointer.png';
import markerIcon from './../../../images/wbu-map-pointer.png';
import dscImage from './../../../images/WBU-DSC-card.jpg';

@Component({
  controllerAs: 'userProfile',
  template
})

export default class UserProfile {
  static $inject = [
    '$scope',
    '$ngRedux',
    '$state',
    'spinnerService',
    'authService',
    '$uibModal',
    '$timeout',
    'toaster',
    '$rootScope',
    '$stateParams',
    
    'APP',
    '$window'
  ];

  constructor($scope, $ngRedux, $state, $spinner,$auth, $uibModal, $timeout, toaster, $rootScope,   $stateParams, APP, $window) {
    const disconnect = $ngRedux.connect(this.mapState)(this);

    this.$ngRedux = $ngRedux;
    this.$state = $state;
    this.$stateParams = $stateParams;
    this.$window = $window;
    this.$auth = $auth;
    
    this.APP = APP;
    this.logoIcon = logoIcon;
    this.houseIcon = houseIcon;
    this.user = user;
    this.dscImage = dscImage;
    this.$uibModal= $uibModal;
    this.searchIcon = searchIcon;
    this.markerIcon = markerIcon;
    this.higlightedmarkerIcon = higlightedmarkerIcon;
    this.$timeout = $timeout;
    this.toaster = toaster;
    this.spinner = $spinner;
    $spinner.show('appSpinner');
    $auth.getDscImage()
    .then(success => {
      // console.log("DSC image: ",success.data);
      this.cloudDscImage = success.data.dscImage;
    })
    .catch(err => {
      this.$auth.printCustomerGenericLogs(err);
      console.log("Error in fetching DSC image: ");
      this.cloudDscImage = this.dscImage;
    });
    $spinner.show('appSpinner');
    $auth.setAllStores();
    if ($auth.isLoggedIn()) {
      $auth.getUserProfile()
          .then(success => $auth.getStoreDetail(success.data.store.storeURLName))
          .catch(err => {
            this.$auth.printCustomerGenericLogs(err);
          })
    .finally(() => {
      $spinner.hide('appSpinner');
      if(this.store.storeCode==this.APP.ORDER.CLOSED_STORE.storeCode){
        this.closedStorePopup();
      }
    });
    }
    else {
      let guestStore = $auth.getGuestStoreDetail();
      $auth.getStoreDetail(guestStore.storeName)
          .finally(() => $spinner.hide('appSpinner'));

    }
    var listener1 =  $rootScope.$on('storeSelected', () => { this.confirmChangeStore($rootScope.selectedStoreId); } );

    
    $scope.$on('$destroy', disconnect);
    listener1();
  }

  mapState(state) {
    return {
      detail: state.auth.profile,
      store: state.auth.storeDetail,
      storesList : state.auth.storesList
    };
  }

  confirmChangeStore(storeId) {
    var $ctrl;
    $ctrl = this;
    $ctrl.storeId = storeId;
    this.$uibModal.open({
      size: 'sm',
      template: '<div class="modal-body" id="modal-body" >' +
      '<div class="password-container margin-ten">'+
      '<input class="form-control" type="password" id="passwordIdUserProfile" ng-model="password" placeholder="Enter Password">'+
        `<i class="far fa-eye-slash" ng-click="togglePassword('passwordIdUserProfile','togglePasswordUserProfile')" id="togglePasswordUserProfile"
                style="cursor: pointer;"></i></div>`+
        '<h5 class="font-weight-bold">Please enter your password to change your store</h5>' +
        '<p class="font-weight-bold" style="font-size:smaller">Please Note: You are changing your active home store. All WBU stores are locally owned and operated, and Daily Savings Club memberships are only valid at the store where purchased.  You may purchase a new DSC membership at your new home store. Club discounts, points balance, and Bird Bucks will be displayed for your active store if applicable. <span ng-if="!isClosedStore">You may switch back to your original home store at any time and all eligible points, discounts, and Bird Bucks will be available.</span><span ng-if="isClosedStore"><br><br><bold style="font-weight:800">Note:</bold> You cannot switch back to this store.</span> </p>' +
      '</div>' +
      '<div class="modal-footer">' +
        '<button class="btn btn-primary" type="button" ng-disabled="!password" ng-click="ok()">OK</button>' +
        '<button class="btn btn-primary m-l-1" type="button" ng-click="cancel()">Go Back</button>' +
      '</div>',
      controller: ['$scope',  '$uibModalInstance', 'authService',
        function($scope, $uibModalInstance, $auth) {

          $scope.isClosedStore = $ctrl.detail.store.storeCode==$ctrl.APP.ORDER.CLOSED_STORE.storeCode? true : false;
          $scope.togglePassword = (passwordId,toggleId) => {
            $auth.togglePassword(passwordId,toggleId);
          };

          $scope.ok = () => {
            // console.log($scope.password,  $ctrl.storeId);
           
               var data = {
                 "newStoreId":$ctrl.storeId,
                 "password":$scope.password
               
               };
               $ctrl.spinner.show('appSpinner');
               $auth.changeStore(data).then( data => {
                 if(data.status == 200) {
                 $ctrl.toaster.pop('success', 'Store has been changed successfully');
                 $ctrl.$timeout(() => { location.reload(); },1500);          
                 }
                 else {
                  $ctrl.toaster.pop('success', data.statusText);
                 }
                 // 
                 $ctrl.spinner.hide('appSpinner');
               } ).catch(err => {
                this.$auth.printCustomerGenericLogs(err);
                $ctrl.spinner.hide('appSpinner');
                $ctrl.toaster.pop('success', err.data.message);
               
              });
               

             $uibModalInstance.close();
          };
          $scope.cancel = () => $uibModalInstance.dismiss('cancel');
        }
      ]
    });
  }

  showLoginPopUp() {
    let msg = 'Text';
    var $ctrl;
    $ctrl = this;
    $ctrl.higlightedmarkerIcon =this.higlightedmarkerIcon;
    $ctrl.markerIcon = this.markerIcon;
    this.$uibModal.open({
      size: 'lg',
      template: 
      '<div class="modal-body p-1-1 store_selector_modal" id="modal-body" > <b>Store Selector</b> <div class="pull-right" ng-click="cancel()">close</div><hr class="store-hr">' +
        '<div class="row">'+
          '<div class="col-md-3 p-l-0 p-r-0">'+
            '<div class="col-md-12 p-l-1 p-r-1">'+
              '<div class="col-md-12 p-l-0 p-r-0">'+
              '<div style="padding: 0;">'+
              '<form class="input-group" style="text-align: center;padding: 3px;">'+
              '<input type="text"  placeholder="Search by city, state or zip" ng-model="zipcode"  class="form-control" style="background: #ffffff; border-color: rgb(193, 191, 191) !important; height:37px;">'+
              '<span class="input-group-btn"  >'+
              '<button type="submit"  ng-click="ok()" class="btn btn-primary btn-sm"  style="background-color: #ffffff;border-color: rgb(193, 191, 191);padding: 0;border-left:none; height:37px;">'+
              '<img src="'+this.searchIcon+'" style="height: 100%;padding: 8px">'+
              '</button>'+
              '</span>'+
              '</form>'+
              '</div>'+
              '</div>'+
            '</div>'+
          '<br/><div class="col-md-12 p-l-1 p-r-1">'+
            '<div class="col-md-12 p-l-0 p-r-0">'+ 
            '<div ng-if="stores.length == 0 && noStoresFound" class="p-l-1 p-t-1"><b>No Stores Found! Please Try Again.</b> </div>'+
              ' <div style="max-height:441px;  overflow-y: auto; overflow-x: hidden;"><div  ng-click="selectStore($index,store,store.storeURLName)" ng-class="( selectedStore == store.storeURLName ) ? selectedStoreClass : notSelectedClass " ng-repeat="store in stores" class="col-md-12 p-r-0 p-l-0 store-dt-div">'+
                '<div  class="row store-nm-div">'+
                '<div class="col-md-8 col-xs-8 p-r-0 p-l-1" >{{$index + 1}}) {{store.city}}'+ 
                '<div class="col-md-12 store-add-div">{{store.addressLine1}}<br/> <span ng-if="store.addressLine2">{{store.addressLine2}}.<br/></span> {{store.city}}, {{store.state}}   {{store.zip}} <br /><span ng-if="store.phoneNumber">{{store.phoneNumber | telFormat}}<br/></span></div>'+
                  '</div> '+
                  '<div class="col-md-4 col-xs-4 p-r-1 p-l-1 pull-right rt-align">'+
                  '<button ng-click="goToSignUp(store, store.storeURLName)" type="button" class="btn btn-primary btn-block-store-selector btn-sm-text mockup-btn sm-btn-bx">'+
                  '<span  class="search-span">Shop Now</span>'+
                '</button>'+
                  '</div>'+
                '</div>'+
                
              '</div> </div>'+
            '<div class="col-md-12 p-r-0 p-l-0 closest-div">'+
              '<div class="col-md-12 p-r-0 p-l-0">'+
                '<div ng-if="stores.length > 0 && selectStore" class="col-md-12 p-r-0 searchStoreText">'+
               '<a ng-click="loadMore()" ng-if="count < 15"><span class="search-span">+ view more store</span> </a>'+

            '</div>'+
            '</div>'+
            '</div>'+

            
            '</div>'+
          '</div>'+
        '</div>'+
     '<div class="col-md-9 hidden-sm-down" map-lazy-load="https://maps.google.com/maps/api/js?key=AIzaSyBMt42lgfunhhzqUsR0zT_rv4-LlMEKtoc">'+
     '<map center="[{{lat}},{{long}}]" zoom="{{zoom}}" style="display:block; width:auto; height:500px;"> '+
     '<info-window id="storeInfo" max-width="200">'+
     '<div ng-non-bindable="">'+
       '<div class="scrollFix">'+
       '<div class="row">'+
       '<div class="col-md-8 col-xs-8 p-r-1 p-l-1" style="font-size: 0.9rem; font-weight: 300;font-weight: bold; padding: 0.5em 0.8em;" >{{storeIndex}}) {{storeObj.city}}'+ 
       '<div class="col-md-12 store-add-div">{{storeObj.addressLine1}}<br/> <span ng-if="storeObj.addressLine2">{{storeObj.addressLine2}}.<br/></span> {{storeObj.city}}, {{storeObj.state}}   {{storeObj.zip}} <br /><span ng-if="storeObj.phoneNumber">{{storeObj.phoneNumber | telFormat}}<br/></span></div>'+
       '</div>'+
       //  '<div class="col-xs-12 pb-4 font-weight-bold" style="color: #a4182d">Wild Birds Unlimited</div>'+
       //  '<div class="col-xs-12">'+
       //    '<div class="m-b-0">'+
       //    '<span class="font-weight-bold">{{storeObj.name}}</span><br />'+
       //    '<span>{{storeObj.addressLine1}}<br />'+
       //    '{{storeObj.city}},{{storeObj.state}}{{storeObj.country}}<br/>'+
       //    'Phone: {{storeObj.phoneNumber | telFormat}}</span><br />'+
       //    '<a href="mailto:{{storeObj.email}}" class="blue-colored">{{storeObj.email}}</a>'+
       //    '</div>'+
       //  '</div>'+
      '</div>'+
    '</div>'+
   '</div>'+
   '</info-window>'+
     '<marker id="{{pin.storeCode}}" on-click="showStoreInfo($index,pin)" ng-repeat="pin in stores" position="{{pin.lat}},{{pin.lng}}" icon="{{selectedStore == pin.storeURLName?higlightedmarkerIcon:markerIcon}}" title="{{pin.name}}"></marker>'+
     '</map>'+
     '</div>',
      controller: ['$rootScope','$scope', '$uibModalInstance', 'authService', '$state', '$stateParams', '$window','NgMap',
        function($rootScope,$scope, $uibModalInstance, $auth, $state, $stateParams, $window,NgMap) {
          this.$state = $state;
          $scope.selectedStoreClass = "selectedStore";
          $scope.notSelectedClass = "";
          $scope.lat = '37.274053';
          $scope.long = '-103.535156';
          $scope.zoom = 4;
          $scope.count = 5;
          $scope.noStoresFound = false;
          $scope.stores = [];
          $scope.higlightedmarkerIcon=$ctrl.higlightedmarkerIcon;
          $scope.markerIcon = $ctrl.markerIcon;
          $scope.notMoreThanone = 0;

          NgMap.getMap()
          .then(map => {
           console.log('map', map);
            $scope.map = map;
          });
          $scope.showStoreInfo = (e,index,storeObj) => {
            $scope.changeStyle();
            $scope.selectedStore = storeObj.storeURLName;
            $scope.storeIndex = index+1;
            console.log('storeObj', storeObj);
             $scope.storeObj = storeObj;
             $scope.map.showInfoWindow('storeInfo', storeObj.storeCode);
          };
          $scope.ok = () => {
            //  $uibModalInstance.close();
            $scope.count = 5;
            let data = {
              "searchKey" : $scope.zipcode,
              "noOfStores": 5

            };
            // if ($ctrl.storeName=='' || $ctrl.storeName == $ctrl.APP.ORDER.ORDER_URL.browseUrl) {
            //   data.isSEORequest = true;
            // }
            let stores = $auth.getStoresbyZipcode(data);
            stores.then(success => {
              $scope.stores = success.data;
              $scope.lat = $scope.stores[0].lat;
              $scope.long = $scope.stores[0].lng;
              $scope.zoom = 4;
              $scope.noStoresFound = false;
              console.log(success.data);
              if($scope.stores.length == 0) {
                $scope.noStoresFound = true;
              }
              
              // $state.go('signup', {
              //   storeName: 'indianapolis'
              // });
        }, error => {
          $scope.noStoresFound = true;
        });
          };
          $scope.loadMore = () => {
            //  $uibModalInstance.close();
            if($scope.count) {
              $scope.count = $scope.count + 5;
            } else {
              $scope.count = 10;
            }
            let data = {
              "searchKey" : $scope.zipcode,
              "noOfStores": $scope.count

            };
            // if ($ctrl.storeName=='' || $ctrl.storeName == $ctrl.APP.ORDER.ORDER_URL.browseUrl) {
            //   data.isSEORequest = true;
            // }
            let stores = $auth.getStoresbyZipcode(data);
            stores.then(success => {
              $scope.stores = success.data;
              console.log(success.data);
              // this.test();
              // $state.go('signup', {
              //   storeName: 'indianapolis'
              // });
        });
          };
          $scope.formatMobileNum = (num, format) => {
            
            var unFormattedNum = num;
            var position1 = 0;
            var position2 = 4;
            var position3 = 9;
            var qFormattedNum = [unFormattedNum.slice(0, position1), "(", unFormattedNum.slice(position1)].join('');
            var hFormattedNum = [qFormattedNum.slice(0, position2), ") ", qFormattedNum.slice(position2)].join('');
            var FormattedNum = [hFormattedNum.slice(0, position3), "-", hFormattedNum.slice(position3)].join('');
            return FormattedNum;
        };
          $scope.cancel = () => {
            
            $uibModalInstance.close();
          };
          $scope.selectStore = (index, store, item) => {
            $scope.showStoreInfo(item,index,store);
           $scope.selectedStore = item;
           $scope.storeObj = store;
           $scope.lat = store.lat;
           $scope.long = store.lng;
          };

          // InfoWindow fix for googlemap
           $scope.changeStyle = () => {
            if ($scope.notMoreThanone < 2) {
              console.log("Inside if $scope.notMoreThanone", $scope.notMoreThanone);
              var selectorText = '.gm-style .gm-style-iw-c';
              var replace_infowindow = 'replace-infowindow';
              var arrow_selector = '.gm-style-iw-a::after';
              var replace_arrow_selector = 'replace_arrow_a::after';
              var theRules = [];
              for (var i = 0; i < document.styleSheets.length; i++) {
                try {
                  if (document.styleSheets[i].cssRules) {
                    for (var j = 0; j < document.styleSheets[i].cssRules.length; j++) {
                      if (document.styleSheets[i].cssRules[j].selectorText == selectorText
                        || document.styleSheets[i].cssRules[j].selectorText == replace_infowindow
                        || document.styleSheets[i].cssRules[j].selectorText == arrow_selector
                        || document.styleSheets[i].cssRules[j].selectorText == replace_arrow_selector) {
                        if (document.styleSheets[i].cssRules[j].selectorText == selectorText) {
                          document.styleSheets[i].cssRules[j].selectorText = replace_infowindow;
                        }
                        else if (document.styleSheets[i].cssRules[j].selectorText == replace_infowindow) {
                          document.styleSheets[i].cssRules[j].selectorText = selectorText;
                        }
                        else if (document.styleSheets[i].cssRules[j].selectorText == arrow_selector) {
                          document.styleSheets[i].cssRules[j].selectorText = replace_arrow_selector;
                        }
                        else if (document.styleSheets[i].cssRules[j].selectorText == replace_arrow_selector) {
                          document.styleSheets[i].cssRules[j].selectorText = arrow_selector;
                        }
                      }
                    }
                  }
                } catch (e) {
                  // console.log("Some Error");
                  this.$auth.printCustomerGenericLogs(e);
                }

              }
            } else {
              // console.log("Else part :");
            }
            $scope.notMoreThanone = $scope.notMoreThanone + 1;
          };

          $scope.goToProductPage = (store, item) => {
            $rootScope.selectedStoreId = store.id;
            $rootScope.$emit('storeSelected');
            $uibModalInstance.close();
          };
          $scope.goToSignUp = (store, item) => {
            $rootScope.selectedStoreId = store.id;
            $rootScope.$emit('storeSelected');
            $ctrl.confirmChangeStore(store.id);
            // $uibModalInstance.close();
          };
        }
      ]

    });
  }

  goToHomePage() {
    let storeName = '';
    if (this.$stateParams.storeName && this.$stateParams.storeName != this.APP.ORDER.ORDER_URL.browseUrl) {
      storeName = this.$stateParams.storeName;
    } else {
      if (this.detail.store && this.detail.store.storeName) {
        storeName = this.detail.store.storeURLName;
      } else {
        storeName = this.$auth.getGuestStoreDetail().storeName;
      }
    }
    if (storeName) {
      this.$window.location.href = '/' + storeName;
    } else {
      this.$state.go('home');

    }
  }

  getFormattedDate(date) {
    return date ?
    `${new Date(date).getMonth() + 1}/${new Date(date).getDate()}/${new Date(date).getFullYear()}`
    : '';
  }

  syncedToday() {
    let syncDate = new Date(this.detail.customer.lastSyncDateTime);
    let currentDate = new Date();
   // console.log(syncDate.getDate() === currentDate.getDate());
    return syncDate.getDate() === currentDate.getDate();
  }

  isDscMember() {
    if (!this.detail.customer) return false;
    return this.detail.customer.dscId === 'C' && new Date() <= new Date(this.detail.customer.dscExpireDate);
  }

  isDscButExpired() {
    if (!this.detail.customer) return false;
    return this.detail.customer.dscId === 'C' && new Date() > new Date(this.detail.customer.dscExpireDate);
  }

  isMobileOnly() {
    return this.$auth.isMobileDevice();
  }

  closedStorePopup() {
    var $ctrl=this;
    this.$uibModal.open({
      size: 'sm',
      template: '<div class="modal-body" id="modal-body" >' +
        '<h5 class="font-weight-bold">Store is closed</h5>' +
        '<p class="font-weight-bold" style="font-size:smaller">Your current Wild Birds Unlimited Store is permanently closed. You can continue shopping by selecting another nearby location. Please scroll down to the bottom of the page and click "Shop Another Store." </p>' +
      '</div>' +
      '<div class="modal-footer">' +
        '<button class="btn btn-primary" type="button" ng-click="ok()">OK</button>' +
      '</div>',
      controller: ['$scope',  '$uibModalInstance', 'authService',
        function($scope, $uibModalInstance, $auth) {
          $scope.ok = () => {
             $uibModalInstance.dismiss('cancel');
          };
          // $scope.cancel = () => $uibModalInstance.dismiss('cancel');
        }
      ]
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/dashboard/user-profile/user-profile.js